<template>
  <section class="relative w-full main-page">
    <div class="pt-5 flex items-between client-status-block rounded-lg scroll-styling top relative"

    >
      <router-view></router-view>

    </div>
  </section>
</template>

<script>
</script>
